import { FaqJsonLd } from '@/features/seo/components/FaqJsonLd';

import { LegalPageLayout } from './LegalPageLayout';

export function FaqPage() {
  return (
    <LegalPageLayout title="Domande Frequenti">
      <FaqJsonLd />
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
      
                    <h2>FAQ Klaro7</h2>
                    <p>Klaro7 è affidabile? Tutto quello che devi sapere sui consulti online sicuri</p>
      
                    <h3>Qual è il significato del nome Klaro7?</h3>
                    <p>Il nome Klaro7 nasce da un&apos;idea semplice: portare chiarezza in un settore spesso caratterizzato da messaggi confusi o poco trasparenti.</p>
                    <p>La parola «Klaro» richiama il concetto di chiarezza, comprensione e visione più limpida delle proprie situazioni personali.</p>
                    <p>Il numero 7, invece, è da sempre considerato un numero simbolico legato alla riflessione, alla ricerca interiore e alla conoscenza.</p>
                    <p>Unendo questi due elementi nasce Klaro7: uno spazio pensato per offrire momenti di ascolto, dialogo e comprensione.</p>
      
                    <h3>Perché Klaro7 parla di chiarezza?</h3>
                    <p>Klaro7 nasce con l&apos;obiettivo di offrire un ambiente più semplice e trasparente rispetto a quanto spesso si trova in questo settore.</p>
                    <p>L&apos;idea alla base della piattaforma è che il consulto debba essere vissuto come un momento di dialogo e di riflessione, senza creare paure o aspettative irrealistiche.</p>
                    <p>Per questo motivo Klaro7 promuove un approccio basato su:</p>
                    <ul>
                      <li>chiarezza nella comunicazione</li>
                      <li>rispetto dell&apos;utente</li>
                      <li>professionalità dei consulenti</li>
                      <li>trasparenza nel funzionamento del servizio</li>
                    </ul>
      
                    <h3>La filosofia Klaro7</h3>
                    <p>Klaro7 non nasce per alimentare paure. Nasce per portare chiarezza.</p>
                    <p>In un settore spesso caratterizzato da confusione e promesse poco realistiche, il nostro obiettivo è offrire uno spazio semplice e trasparente dove il consulto possa diventare un momento di ascolto, riflessione e comprensione.</p>
                    <p>Da questa visione nasce il nostro slogan:</p>
                    <p>Scopri, comprendi, vivi con chiarezza.</p>
      
                    <h2>Natura del servizio</h2>
      
                    <h3>Cos&apos;è Klaro7 e come funzionano i consulti online?</h3>
                    <p>Klaro7 è una piattaforma italiana di consulti simbolici online che mette in contatto utenti e consulenti selezionati per offrire momenti di ascolto, riflessione e orientamento personale.</p>
                    <p>Non siamo un call center di cartomanzia tradizionale. Klaro7 nasce per portare chiarezza e semplicità in un settore spesso confuso, offrendo un ambiente trasparente, sicuro e rispettoso.</p>
                    <p>I consulenti presenti sulla piattaforma operano secondo linee guida etiche e comunicative interne, pensate per garantire un approccio chiaro, non manipolativo e orientato al benessere dell&apos;utente.</p>
      
                    <h3>Perché scegliere Klaro7?</h3>
                    <p>Klaro7 nasce con l&apos;obiettivo di offrire un ambiente chiaro, semplice e professionale in cui gli utenti possano confrontarsi con consulenti selezionati.</p>
                    <p>La piattaforma è stata progettata per mettere al centro tre elementi fondamentali:</p>
                    <ul>
                      <li>trasparenza nel funzionamento del servizio</li>
                      <li>qualità dei consulenti presenti sulla piattaforma</li>
                      <li>rispetto dell&apos;utente e delle sue esigenze</li>
                    </ul>
      
                    <h3>Cosa rende Klaro7 diversa da altre piattaforme?</h3>
                    <p>Klaro7 si distingue per un approccio orientato alla chiarezza e alla qualità del servizio.</p>
                    <p>Tra gli elementi che caratterizzano la piattaforma vi sono:</p>
                    <ul>
                      <li>un processo di selezione dei consulenti</li>
                      <li>profili professionali dettagliati</li>
                      <li>sistema di recensioni degli utenti</li>
                      <li>consulti disponibili 24 ore su 24</li>
                      <li>un ambiente progettato per favorire un dialogo sereno e rispettoso</li>
                    </ul>
                    <p>L&apos;obiettivo è offrire un&apos;esperienza basata su fiducia, semplicità e trasparenza.</p>
      
                    <h3>Chi può utilizzare Klaro7? È necessario essere maggiorenni?</h3>
                    <p>L&apos;accesso e l&apos;utilizzo della piattaforma Klaro7 sono riservati esclusivamente a persone maggiorenni (18+).</p>
                    <p>Registrandosi, l&apos;utente dichiara sotto la propria responsabilità di aver compiuto 18 anni.</p>
                    <p>Klaro7 non consente l&apos;utilizzo del servizio da parte di minori e si riserva il diritto di sospendere eventuali account che risultino non conformi a questo requisito.</p>
      
                    <h3>Klaro7 offre consulenze professionali di tipo legale, medico o psicologico?</h3>
                    <p>No. I consulti presenti su Klaro7 non sostituiscono in alcun modo il parere di professionisti qualificati come medici, psicologi, avvocati o consulenti finanziari.</p>
                    <p>I consulti hanno natura esclusivamente simbolica e di intrattenimento evoluto, finalizzati alla riflessione personale e all&apos;ascolto.</p>
                    <p>Se hai bisogno di supporto medico, legale o psicologico, ti invitiamo sempre a rivolgerti a professionisti abilitati.</p>
      
                    <h3>I consulti su Klaro7 prevedono previsioni certe o garanzie sul futuro?</h3>
                    <p>No. Nessun consulente può garantire eventi futuri o risultati certi.</p>
                    <p>Klaro7 promuove un approccio basato sulla chiarezza e sulla responsabilità personale. Il consulto è uno spazio di confronto e interpretazione simbolica, non una promessa di eventi futuri.</p>
                    <p>Diffidiamo da chi usa paura o certezze assolute per influenzare le persone.</p>
      
                    <h3>I consulenti di Klaro7 sono dipendenti della piattaforma?</h3>
                    <p>I consulenti operano in modo autonomo e indipendente. Klaro7 offre la piattaforma tecnologica che permette l&apos;incontro tra utente e consulente, garantendo standard di qualità, regole etiche e sicurezza del servizio.</p>
                    <p>Ogni consulente è responsabile dei contenuti espressi durante il consulto, nel rispetto delle linee guida della piattaforma.</p>
      
                    <h3>Klaro7 è affidabile?</h3>
                    <p>Klaro7 nasce con l&apos;obiettivo di rendere il consulto online più trasparente, più chiaro e più rispettoso.</p>
                    <p>Ogni consulente viene selezionato secondo criteri interni e deve rispettare regole precise di comportamento e comunicazione.</p>
                    <p>Klaro7 promuove un percorso di crescita e aggiornamento continuo dei propri consulenti, affinché il consulto rimanga uno spazio di ascolto responsabile e consapevole.</p>
                    <p>Inoltre:</p>
                    <ul>
                      <li>I pagamenti avvengono tramite sistemi sicuri</li>
                      <li>I dati sono protetti nel rispetto della normativa vigente</li>
                      <li>Sono vietate pratiche manipolative o intimidatorie</li>
                    </ul>
                    <p>Affidabilità significa chiarezza. Ed è il motivo per cui Klaro7 è nata.</p>
      
                    <h2>Disponibilità del servizio</h2>
      
                    <h3>Il servizio Klaro7 è disponibile 24 ore su 24?</h3>
                    <p>Sì. La piattaforma Klaro7 è attiva 24 ore su 24, 7 giorni su 7, per permettere agli utenti di accedere ai consulti in qualsiasi momento della giornata.</p>
      
                    <h3>Posso parlare con un consulente anche di notte o nei giorni festivi?</h3>
                    <p>Sì. Molti consulenti Klaro7 offrono disponibilità anche nelle ore serali, notturne e nei giorni festivi.</p>
                    <p>La presenza dei consulenti può variare nel corso della giornata, ma la piattaforma resta sempre accessibile.</p>
      
                    <h3>Come faccio a sapere quali consulenti sono disponibili in quel momento?</h3>
                    <p>All&apos;interno della piattaforma è possibile vedere in tempo reale lo stato di ogni consulente:</p>
                    <ul>
                      <li>Online → disponibile per il consulto immediato</li>
                      <li>Occupato → momentaneamente impegnato in un altro consulto</li>
                      <li>Offline → non disponibile in quel momento</li>
                    </ul>
                    <p>Questo sistema consente di scegliere facilmente il consulente disponibile.</p>
      
                    <h3>Posso prenotare un consulto se il consulente non è online?</h3>
                    <p>Al momento no. Tuttavia, potrai inviare un messaggio direttamente dal tuo profilo quando il servizio sarà attivo. Ricorda che ogni consulente indica i propri orari di disponibilità all&apos;interno della propria scheda personale.</p>
      
                    <h3>Posso consultare Klaro7 anche di notte o nei giorni festivi?</h3>
                    <p>Sì. Molti consulenti Klaro7 offrono disponibilità anche nelle ore notturne, nei weekend e nei giorni festivi, grazie a un sistema di rotazione che permette alla piattaforma di mantenere attivo il servizio.</p>
      
                    <h2>Registrazione e accesso alla piattaforma</h2>
      
                    <h3>Chi può registrarsi su Klaro7?</h3>
                    <p>La registrazione alla piattaforma Klaro7 è consentita esclusivamente a persone maggiorenni.</p>
                    <p>Registrandosi alla piattaforma, l&apos;utente dichiara di aver compiuto 18 anni e di accettare le Condizioni Generali di utilizzo del servizio.</p>
      
                    <h3>Come mi registro su Klaro7?</h3>
                    <p>Per registrarti su Klaro7 è sufficiente:</p>
                    <ol>
                      <li>Accedere alla pagina di registrazione</li>
                      <li>Inserire i dati richiesti in modo corretto e veritiero</li>
                      <li>Confermare l&apos;indirizzo email</li>
                    </ol>
                    <p>La registrazione è gratuita e ti permette di accedere ai consulti online in modo semplice e sicuro.</p>
                    <p>Klaro7 richiede dati autentici per garantire un ambiente trasparente e tutelare tutti gli utenti.</p>
      
                    <h3>Perché devo verificare il mio numero/email tramite codice OTP?</h3>
                    <p>Per garantire la sicurezza degli utenti e prevenire utilizzi impropri, Klaro7 utilizza un sistema di verifica tramite codice OTP (One Time Password).</p>
                    <p>La verifica serve a:</p>
                    <ul>
                      <li>Confermare l&apos;identità dell&apos;utente</li>
                      <li>Ridurre account falsi o duplicati</li>
                      <li>Aumentare la sicurezza delle operazioni</li>
                    </ul>
                    <p>La procedura è semplice e richiede pochi secondi.</p>
      
                    <h3>Posso utilizzare un nickname invece del mio nome reale?</h3>
                    <p>Sì. Durante l&apos;utilizzo della piattaforma l&apos;utente può scegliere di utilizzare un nickname per tutelare ulteriormente la propria riservatezza nei confronti dei consulenti e degli altri utenti.</p>
      
                    <h3>La registrazione su Klaro7 è gratuita?</h3>
                    <p>Sì. La creazione dell&apos;account è completamente gratuita.</p>
                    <p>Pagherai solo i crediti che deciderai di acquistare per effettuare un consulto. Non sono previsti abbonamenti automatici o costi nascosti.</p>
      
                    <h3>Posso avere più di un account?</h3>
                    <p>No. Per garantire correttezza e sicurezza, ogni utente può avere un solo account personale.</p>
                    <p>Il sistema di verifica OTP contribuisce a prevenire la creazione di account multipli non autorizzati.</p>
                    <p>La creazione di account multipli può comportare la sospensione o la chiusura dell&apos;account, secondo quanto previsto dalle Condizioni Generali.</p>
                    <p>Questo aiuta a prevenire abusi e contestazioni.</p>
      
                    <h3>Devo inserire dati reali durante la registrazione?</h3>
                    <p>Sì. È importante fornire dati veritieri e aggiornati.</p>
                    <p>Inserire informazioni false può compromettere la sicurezza dell&apos;account e comportare limitazioni o sospensione.</p>
                    <p>Klaro7 utilizza i dati esclusivamente per finalità legate al funzionamento della piattaforma, nel rispetto della normativa sulla privacy.</p>
      
                    <h3>Cosa succede se dimentico la password?</h3>
                    <p>Se dimentichi la password, puoi utilizzare la funzione «Recupera password» presente nella pagina di accesso.</p>
                    <p>Riceverai un&apos;email con le istruzioni per impostarne una nuova in modo sicuro.</p>
                    <p>Per proteggere il tuo account, ti consigliamo di scegliere una password personale e non condividerla con nessuno.</p>
      
                    <h3>Klaro7 può sospendere o chiudere un account?</h3>
                    <p>Sì, ma solo in caso di violazione delle regole della piattaforma.</p>
                    <p>Ad esempio:</p>
                    <ul>
                      <li>uso improprio del servizio</li>
                      <li>comportamento offensivo o intimidatorio</li>
                      <li>tentativi di frode o abuso</li>
                    </ul>
                    <p>L&apos;obiettivo non è punire, ma mantenere un ambiente rispettoso e sicuro per tutti.</p>
      
                    <h3>Come posso cancellare il mio account?</h3>
                    <p>Puoi richiedere la cancellazione del tuo account contattando il servizio di assistenza tramite i canali indicati sul sito. <a href="mailto:assistenza@klaro7.com">assistenza@klaro7.com</a></p>
                    <p>La richiesta verrà gestita nel rispetto della normativa vigente e delle condizioni contrattuali applicabili.</p>
      
                    <h3>I miei dati personali sono al sicuro?</h3>
                    <p>Sì. Klaro7 adotta misure tecniche e organizzative adeguate per proteggere i dati personali degli utenti.</p>
                    <p>I dati vengono trattati nel rispetto della normativa europea in materia di protezione dei dati (GDPR) e utilizzati esclusivamente per finalità legate al funzionamento del servizio.</p>
                    <p>La sicurezza digitale è una priorità per Klaro7.</p>
      
                    <h2>Pagamenti e crediti</h2>
      
                    <h3>Come funzionano i pagamenti su Klaro7?</h3>
                    <p>Su Klaro7 i consulti funzionano tramite un sistema di crediti prepagati.</p>
                    <p>Prima di iniziare un consulto, l&apos;utente acquista un pacchetto di crediti. Durante il consulto, i crediti vengono scalati in base alla durata della sessione.</p>
                    <p>Questo sistema garantisce:</p>
                    <ul>
                      <li>Trasparenza sui costi</li>
                      <li>Controllo della spesa</li>
                      <li>Nessun addebito automatico</li>
                    </ul>
      
                    <h3>I pagamenti su Klaro7 sono sicuri?</h3>
                    <p>Sì. I pagamenti vengono gestiti tramite sistemi di pagamento certificati e sicuri.</p>
                    <p>Klaro7 non conserva direttamente i dati completi delle carte di pagamento, che vengono trattati attraverso provider autorizzati nel rispetto degli standard di sicurezza internazionali.</p>
                    <p>La protezione dei dati finanziari è una priorità assoluta.</p>
      
                    <h3>I crediti acquistati scadono?</h3>
                    <p>In generale, i crediti non hanno una scadenza prefissata. L&apos;unico caso in cui potrebbero essere disattivati è se l&apos;account rimane completamente inattivo per oltre 12 mesi consecutivi. Ti consigliamo comunque di consultare i dettagli specifici di ogni pacchetto prima dell&apos;acquisto per conoscere tutte le condizioni d&apos;uso.</p>
      
                    <h3>Posso chiedere il rimborso dei crediti acquistati?</h3>
                    <p>L&apos;acquisto dei crediti è considerato definitivo una volta completata la transazione.</p>
                    <p>I crediti non sono rimborsabili, salvo i casi espressamente previsti dalla legge o specificati nelle Condizioni Generali.</p>
                    <p>Prima di procedere all&apos;acquisto, l&apos;utente è sempre informato in modo chiaro del funzionamento del servizio.</p>
      
                    <h3>Cosa succede se interrompo un consulto?</h3>
                    <p>Se il consulto viene interrotto dall&apos;utente, i crediti verranno scalati solo per il tempo effettivamente utilizzato.</p>
                    <p>In caso di interruzione per problemi tecnici imputabili alla piattaforma, Klaro7 potrà valutare eventuali ripristini o compensazioni secondo le condizioni previste.</p>
      
                    <h3>Cosa succede in caso di pagamento non autorizzato o contestazione?</h3>
                    <p>In caso di contestazione di pagamento (chargeback), Klaro7 si riserva il diritto di verificare l&apos;effettiva erogazione del servizio.</p>
                    <p>Se il consulto risulta regolarmente fruito, la piattaforma potrà:</p>
                    <ul>
                      <li>sospendere temporaneamente l&apos;account</li>
                      <li>richiedere chiarimenti</li>
                      <li>adottare misure a tutela del servizio</li>
                    </ul>
                    <p>L&apos;obiettivo è proteggere sia gli utenti corretti sia i consulenti da utilizzi impropri del sistema.</p>
      
                    <h3>Sono previsti abbonamenti automatici o rinnovi forzati?</h3>
                    <p>No. Klaro7 non prevede abbonamenti automatici né rinnovi non autorizzati.</p>
                    <p>Ogni acquisto è volontario e deve essere confermato esplicitamente dall&apos;utente.</p>
      
                    <h3>Posso trasferire i miei crediti ad un altro utente?</h3>
                    <p>No. I crediti sono personali e collegati all&apos;account dell&apos;utente che li ha acquistati.</p>
                    <p>Non possono essere ceduti, trasferiti o convertiti in denaro.</p>
      
                    <h2>Bonus Klaro7 e promozioni per nuovi utenti</h2>
      
                    <h3>Bonus di Benvenuto «7 Minuti Klaro7»</h3>
                    <p>Il Bonus di Benvenuto «7 Minuti Klaro7» consente ai nuovi utenti di effettuare un primo consulto gratuito della durata massima di 7 minuti con uno qualsiasi dei consulenti presenti sulla piattaforma.</p>
                    <p>L&apos;iniziativa è pensata per permettere all&apos;utente di conoscere il servizio e valutare l&apos;esperienza prima di effettuare una ricarica.</p>
                    <p>Il bonus:</p>
                    <ul>
                      <li>è riservato esclusivamente ai nuovi utenti maggiorenni</li>
                      <li>è attivabile solo dopo verifica dell&apos;account tramite OTP</li>
                      <li>è utilizzabile una sola volta per persona</li>
                      <li>non è convertibile in denaro</li>
                      <li>non è trasferibile</li>
                      <li>non è rimborsabile</li>
                      <li>ha una validità di 20 giorni dalla data di attivazione</li>
                    </ul>
                    <p>Decorso tale termine, il bonus non utilizzato scade automaticamente.</p>
                    <p>Tutti i consulenti aderenti alla piattaforma partecipano automaticamente all&apos;iniziativa, secondo quanto previsto dagli accordi contrattuali.</p>
                    <p>Klaro7 si riserva il diritto di sospendere o annullare il bonus in caso di utilizzo improprio, creazione di account multipli o comportamenti fraudolenti.</p>
      
                    <h3>Cos&apos;è il Bonus Prima Ricarica?</h3>
                    <p>Il Bonus Prima Ricarica è un credito omaggio riconosciuto esclusivamente sulla prima ricarica effettuata.</p>
                    <p>Le soglie attualmente previste sono:</p>
                    <ul>
                      <li>Ricarica €10 → €7 bonus (Totale credito: €17)</li>
                      <li>Ricarica €30 → €20 bonus (Totale credito: €50)</li>
                      <li>Ricarica €50 → €30 bonus (Totale credito: €80)</li>
                    </ul>
                    <p>Il credito bonus:</p>
                    <ul>
                      <li>è valido solo sulla prima ricarica</li>
                      <li>non è prelevabile</li>
                      <li>non è trasferibile</li>
                      <li>non è convertibile in denaro</li>
                      <li>ha validità di 20 giorni dalla data di accredito</li>
                    </ul>
      
                    <h3>È prevista una tariffa promozionale per i nuovi utenti?</h3>
                    <p>Sì. In occasione del Bonus di Benvenuto e della Prima Ricarica, Klaro7 applica una tariffa promozionale di €0,99 al minuto.</p>
                    <p>La tariffa agevolata:</p>
                    <ul>
                      <li>si applica a tutti i consulenti aderenti alla piattaforma</li>
                      <li>è riservata ai nuovi utenti</li>
                      <li>è valida secondo le condizioni promozionali attive</li>
                      <li>può avere durata limitata</li>
                    </ul>
                    <p>Successivamente si applicheranno le tariffe indicate nel profilo del singolo consulente.</p>
      
                    <h3>I bonus sono sempre disponibili?</h3>
                    <p>I bonus e le iniziative promozionali rappresentano strumenti commerciali variabili nel tempo.</p>
                    <p>Klaro7 si riserva la facoltà di:</p>
                    <ul>
                      <li>modificare</li>
                      <li>sospendere</li>
                      <li>rimodulare</li>
                    </ul>
                    <p>le condizioni promozionali nel rispetto delle disposizioni contrattuali vigenti.</p>
                    <p>Le iniziative promozionali non costituiscono un diritto permanente.</p>
      
                    <h3>Posso richiedere il rimborso del bonus non utilizzato?</h3>
                    <p>No. I crediti promozionali non utilizzati entro il termine di validità non sono rimborsabili né recuperabili.</p>
      
                    <h3>Cashback Mensile (giorno klaro7)</h3>
                    <p>Klaro7 può riconoscere un credito cashback mensile al raggiungimento di determinate soglie di ricarica.</p>
                    <p>Esempio indicativo:</p>
                    <ul>
                      <li>€7 di credito su ricariche complessive mensili comprese tra €100 e €150</li>
                    </ul>
                    <p>Il credito:</p>
                    <ul>
                      <li>è utilizzabile esclusivamente sulla piattaforma</li>
                      <li>non è prelevabile</li>
                      <li>non è trasferibile</li>
                      <li>non è convertibile in denaro</li>
                    </ul>
                    <p>Le soglie e le condizioni sono specificate nelle Condizioni d&apos;Uso aggiornate. (art. 4 bis programma fedeltà)</p>
      
                    <h3>Che cos&apos;è il Bonus Compleanno?</h3>
                    <p>In occasione del compleanno dell&apos;utente, Klaro7 può riconoscere un credito promozionale dedicato.</p>
                    <p>L&apos;erogazione del bonus è subordinata alla presenza di una data di nascita correttamente inserita nell&apos;account.</p>
                    <p>Anche questo bonus:</p>
                    <ul>
                      <li>non è prelevabile</li>
                      <li>può avere una scadenza</li>
                      <li>è soggetto a eventuali condizioni specifiche</li>
                    </ul>
      
                    <h3>I bonus e il cashback sono permanenti?</h3>
                    <p>No. Le iniziative promozionali rappresentano strumenti commerciali che possono essere:</p>
                    <ul>
                      <li>modificati</li>
                      <li>sospesi</li>
                      <li>rimodulati</li>
                    </ul>
                    <p>in qualsiasi momento, nel rispetto delle condizioni contrattuali vigenti.</p>
                    <p>Le iniziative promozionali costituiscono strumenti commerciali variabili nel tempo e non configurano un diritto acquisito permanente per l&apos;utente.</p>
      
                    <h2>Utilizzo dei bonus</h2>
      
                    <h3>In quale ordine viene utilizzato il credito?</h3>
                    <p>Il sistema Klaro7 utilizza automaticamente i crediti secondo il seguente ordine:</p>
                    <ol>
                      <li>Crediti promozionali (bonus)</li>
                      <li>Crediti acquistati dall&apos;utente</li>
                    </ol>
                    <p>Il credito bonus viene quindi sempre utilizzato per primo.</p>
      
                    <h3>Perché il bonus viene utilizzato prima del credito acquistato?</h3>
                    <p>I crediti promozionali hanno una validità limitata (20 giorni dalla data di accredito) per ragioni amministrative e contabili.</p>
                    <p>Per evitare che il bonus scada inutilizzato, il sistema lo utilizza in via prioritaria.</p>
      
                    <h3>Cosa succede se il bonus scade?</h3>
                    <p>I crediti promozionali non utilizzati entro 20 giorni dalla data di accredito:</p>
                    <ul>
                      <li>scadono automaticamente</li>
                      <li>non sono rimborsabili</li>
                      <li>non sono convertibili in denaro</li>
                      <li>non sono recuperabili</li>
                    </ul>
      
                    <h3>Posso scegliere di usare prima il credito acquistato?</h3>
                    <p>No. L&apos;ordine di utilizzo del credito è automatico e non modificabile.</p>
      
                    <h2>Svolgimento del consulto</h2>
      
                    <h3>Come funziona un consulto su Klaro7?</h3>
                    <p>Effettuare un consulto su Klaro7 è semplice e avviene in pochi passaggi:</p>
                    <ol>
                      <li>Registrazione alla piattaforma. L&apos;utente crea un account personale e completa la verifica tramite codice OTP.</li>
                      <li>Accesso al proprio account. Dopo la registrazione è possibile accedere alla piattaforma e consultare i profili dei consulenti disponibili.</li>
                      <li>Scelta del consulente. L&apos;utente può scegliere il consulente leggendo il profilo, le specializzazioni e le recensioni lasciate da altri utenti.</li>
                      <li>Ricarica del credito. Per iniziare un consulto è necessario disporre di credito sul proprio account. Klaro7 può prevedere bonus e promozioni dedicate ai nuovi utenti.</li>
                      <li>Avvio del consulto. Il consulto può avvenire tramite: telefonata; chat; videochiamata; a seconda delle modalità disponibili per il consulente scelto.</li>
                      <li>Durata del consulto. Il consulto dura per il tempo desiderato dall&apos;utente e termina automaticamente quando il credito disponibile viene esaurito o quando l&apos;utente decide di interrompere la conversazione.</li>
                    </ol>
      
                    <h3>Come si svolge un consulto su Klaro7?</h3>
                    <p>Una volta scelto il consulente e avviato il consulto, la sessione si svolge online tramite la modalità prevista (chat, audio o altro sistema indicato sulla piattaforma).</p>
                    <p>I crediti vengono scalati in base alla durata effettiva del consulto.</p>
                    <p>L&apos;utente può interrompere la sessione in qualsiasi momento.</p>
                    <p>Klaro7 promuove un consulto chiaro, rispettoso e orientato all&apos;ascolto.</p>
      
                    <h3>Posso interrompere il consulto quando voglio?</h3>
                    <p>Sì. L&apos;utente può interrompere il consulto in qualsiasi momento.</p>
                    <p>Verranno scalati esclusivamente i crediti relativi al tempo effettivamente utilizzato.</p>
                    <p>Il controllo rimane sempre nelle tue mani.</p>
      
                    <h3>Il consulente può interrompere un consulto?</h3>
                    <p>Sì, in casi specifici, ad esempio:</p>
                    <ul>
                      <li>comportamento offensivo o inappropriato</li>
                      <li>richieste non conformi alle regole della piattaforma</li>
                      <li>situazioni che esulano dalla natura del servizio</li>
                    </ul>
                    <p>Klaro7 tutela sia l&apos;utente sia il consulente, mantenendo un ambiente rispettoso per entrambi.</p>
      
                    <h3>I consulti sono registrati?</h3>
                    <p>Klaro7 può adottare sistemi di monitoraggio o registrazione per finalità di sicurezza, qualità del servizio o tutela legale, nel rispetto della normativa vigente.</p>
                    <p>Le modalità specifiche sono indicate nelle Condizioni Generali e nell&apos;Informativa Privacy.</p>
      
                    <h3>Il consulto su Klaro7 può creare dipendenza?</h3>
                    <p>Klaro7 promuove un utilizzo consapevole e responsabile del servizio.</p>
                    <p>Il consulto deve essere uno spazio di riflessione e orientamento, non una sostituzione delle proprie decisioni o responsabilità personali.</p>
                    <p>Se senti il bisogno di consulti frequenti o percepisci una dipendenza emotiva dal servizio, ti invitiamo a fermarti e a valutare con lucidità la situazione.</p>
                    <p>La chiarezza significa anche saper dire quando è il momento di fare una pausa.</p>
      
                    <h3>Klaro7 incoraggia consulti ripetuti?</h3>
                    <p>Klaro7 non incoraggia un utilizzo compulsivo del servizio.</p>
                    <p>Ogni consulto dovrebbe rappresentare un momento di confronto e non un meccanismo ripetitivo dettato da ansia o insicurezza.</p>
                    <p>I consulenti sono invitati a mantenere un approccio responsabile e a non incentivare dinamiche di dipendenza.</p>
      
                    <h3>Cosa succede in caso di problemi tecnici durante un consulto?</h3>
                    <p>In caso di interruzioni tecniche imputabili alla piattaforma, Klaro7 potrà valutare eventuali ripristini o compensazioni, secondo quanto previsto dalle Condizioni Generali.</p>
                    <p>Ti invitiamo a contattare tempestivamente l&apos;assistenza per una verifica. <a href="mailto:assistenza@klaro7.com">assistenza@klaro7.com</a></p>
      
                    <h3>Il consulto garantisce risultati concreti nella mia vita?</h3>
                    <p>No. Il consulto non garantisce risultati, eventi futuri o soluzioni automatiche.</p>
                    <p>Le decisioni restano sempre personali.</p>
                    <p>Klaro7 offre uno spazio di ascolto e interpretazione simbolica, non una promessa di eventi certi.</p>
                    <p>Chiarezza prima di tutto.</p>
      
                    <h2>Di cosa si può parlare durante un consulto</h2>
      
                    <h3>Cosa posso chiedere durante un consulto su Klaro7?</h3>
                    <p>Durante un consulto su Klaro7 è possibile affrontare diversi temi legati alla propria vita personale e alle proprie riflessioni.</p>
                    <p>Molti utenti utilizzano i consulti per ricevere un punto di vista o un momento di confronto su aspetti come:</p>
                    <ul>
                      <li>relazioni e sentimenti</li>
                      <li>scelte personali</li>
                      <li>lavoro e percorsi professionali</li>
                      <li>dubbi o momenti di incertezza</li>
                      <li>crescita personale</li>
                    </ul>
                    <p>Il consulto viene spesso vissuto come un momento di dialogo e riflessione.</p>
      
                    <h3>I consulenti danno risposte definitive sul futuro?</h3>
                    <p>I consulti offerti sulla piattaforma non devono essere intesi come certezze assolute o previsioni deterministiche.</p>
                    <p>Il consulto rappresenta piuttosto uno spazio di ascolto e interpretazione che può aiutare l&apos;utente a riflettere sulle proprie situazioni personali.</p>
      
                    <h3>Ci sono argomenti che non possono essere trattati durante un consulto?</h3>
                    <p>Sì. Per garantire un utilizzo responsabile della piattaforma, i consulenti non possono affrontare o fornire indicazioni su temi che richiedono competenze professionali specifiche o regolamentate.</p>
                    <p>A titolo esemplificativo, non possono essere forniti consulti relativi a:</p>
                    <ul>
                      <li>diagnosi o trattamenti medici</li>
                      <li>consulenze legali</li>
                      <li>consulenze finanziarie o di investimento</li>
                    </ul>
                    <p>Per tali materie è sempre opportuno rivolgersi a professionisti qualificati.</p>
      
                    <h3>Il consulto sostituisce il parere di un professionista?</h3>
                    <p>No. I consulti offerti sulla piattaforma Klaro7 hanno finalità di dialogo, orientamento e riflessione personale.</p>
                    <p>Non sostituiscono in alcun modo il parere di professionisti qualificati nei rispettivi ambiti.</p>
      
                    <h2>Come scegliere il consulente</h2>
      
                    <h3>Come posso scegliere il consulente più adatto alle mie esigenze su klaro7?</h3>
                    <p>Klaro7 mette a disposizione diversi strumenti per aiutare gli utenti a scegliere il consulente più adatto.</p>
                    <p>Ogni consulente dispone di un profilo dettagliato nel quale è possibile trovare:</p>
                    <ul>
                      <li>una descrizione personale</li>
                      <li>le specializzazioni e gli ambiti di consulto</li>
                      <li>la tariffa al minuto</li>
                      <li>le modalità di consulto disponibili (telefono, chat o video)</li>
                      <li>le recensioni lasciate dagli utenti</li>
                    </ul>
                    <p>Leggere il profilo del consulente consente di individuare quello che si avvicina maggiormente alle proprie esigenze.</p>
      
                    <h3>Posso leggere le recensioni prima di scegliere un consulente?</h3>
                    <p>Sì. All&apos;interno del profilo di ogni consulente sono disponibili le recensioni lasciate dagli utenti che hanno già effettuato un consulto.</p>
                    <p>Le recensioni rappresentano uno strumento utile per conoscere l&apos;esperienza di altri utenti e orientarsi nella scelta.</p>
      
                    <h3>Tutti i consulenti hanno le stesse competenze?</h3>
                    <p>No. Ogni consulente ha il proprio percorso, le proprie specializzazioni e un approccio personale al consulto.</p>
                    <p>Per questo motivo Klaro7 consente agli utenti di consultare le informazioni presenti nel profilo del consulente per individuare quello più in linea con le proprie aspettative.</p>
      
                    <h3>Posso provare più consulenti?</h3>
                    <p>Sì. Gli utenti possono scegliere liberamente il consulente con cui effettuare un consulto e, se lo desiderano, provare anche consulenti diversi presenti sulla piattaforma.</p>
                    <p>Questo consente di trovare nel tempo il professionista con cui si crea maggiore sintonia.</p>
      
                    <h3>Se non mi trovo bene con un consulente posso cambiarlo?</h3>
                    <p>Sì. Gli utenti possono interrompere il consulto in qualsiasi momento e scegliere un altro consulente disponibile sulla piattaforma.</p>
                    <p>Klaro7 lascia piena libertà di scelta all&apos;utente.</p>
      
                    <h2>Costo dei consulti</h2>
      
                    <h3>Quanto costa un consulto su Klaro7?</h3>
                    <p>Il costo di un consulto su Klaro7 dipende dal consulente scelto e dalla durata della conversazione.</p>
                    <p>Ogni consulente stabilisce la propria tariffa al minuto, che è sempre indicata in modo chiaro nel suo profilo prima dell&apos;inizio del consulto.</p>
                    <p>Questo sistema consente all&apos;utente di scegliere il consulente in base alle proprie preferenze e al proprio budget.</p>
      
                    <h3>Come faccio a conoscere il costo prima di iniziare il consulto?</h3>
                    <p>Prima di avviare un consulto, la piattaforma mostra sempre:</p>
                    <ul>
                      <li>la tariffa al minuto del consulente</li>
                      <li>il credito disponibile nel proprio account</li>
                      <li>la modalità di consulto (telefonata, chat o video)</li>
                    </ul>
      
                    <h3>Le tariffe sono uguali per tutti i consulenti?</h3>
                    <p>No. Ogni consulente può applicare una tariffa diversa in base alla propria esperienza, specializzazione e disponibilità.</p>
                    <p>Questo permette alla piattaforma di offrire una varietà di profili tra cui scegliere.</p>
      
                    <h3>Esistono tariffe promozionali per i nuovi utenti?</h3>
                    <p>Sì. Per permettere ai nuovi utenti di conoscere la piattaforma, Klaro7 può prevedere iniziative promozionali come:</p>
                    <ul>
                      <li>Bonus di Benvenuto</li>
                      <li>Bonus Prima Ricarica</li>
                      <li>tariffe promozionali dedicate ai nuovi utenti</li>
                    </ul>
                    <p>Le condizioni delle promozioni attive sono sempre indicate nelle relative sezioni informative della piattaforma.</p>
      
                    <h3>Il consulto ha una durata minima o massima?</h3>
                    <p>Non esiste una durata obbligatoria del consulto.</p>
                    <p>La durata dipende esclusivamente dalla volontà dell&apos;utente e dal credito disponibile nel proprio account.</p>
                    <p>Il consulto termina automaticamente quando il credito disponibile viene esaurito.</p>
      
                    <h2>Selezione e formazione dei consulenti</h2>
      
                    <h3>Come vengono selezionati i consulenti Klaro7?</h3>
                    <p>Klaro7 adotta un processo di selezione accurato per garantire agli utenti un servizio professionale, serio e trasparente.</p>
                    <p>Ogni candidatura viene valutata attraverso un processo di verifica che può includere:</p>
                    <ul>
                      <li>analisi del profilo professionale</li>
                      <li>valutazione delle competenze dichiarate</li>
                      <li>colloquio conoscitivo</li>
                      <li>verifica dell&apos;approccio etico e comunicativo</li>
                    </ul>
                    <p>L&apos;obiettivo è garantire che i consulenti presenti sulla piattaforma operino nel rispetto degli standard qualitativi di Klaro7.</p>
      
                    <h3>Tutti possono diventare consulenti Klaro7?</h3>
                    <p>No. L&apos;accesso alla piattaforma non è automatico.</p>
                    <p>Klaro7 seleziona con attenzione i consulenti per mantenere un ambiente professionale e garantire agli utenti consulti di qualità.</p>
                    <p>Non tutte le candidature vengono accettate.</p>
      
                    <h3>I consulenti Klaro7 seguono standard professionali?</h3>
                    <p>Sì. I consulenti presenti sulla piattaforma devono rispettare standard professionali e comportamentali definiti da Klaro7.</p>
                    <p>Questi standard riguardano, tra gli altri aspetti:</p>
                    <ul>
                      <li>chiarezza nella comunicazione</li>
                      <li>rispetto dell&apos;utente</li>
                      <li>correttezza professionale</li>
                      <li>qualità dell&apos;esperienza di consulto</li>
                    </ul>
      
                    <h3>Klaro7 prevede percorsi di formazione per i consulenti?</h3>
                    <p>Klaro7 promuove un approccio professionale e responsabile al consulto.</p>
                    <p>Per questo motivo la piattaforma prevede lo sviluppo di iniziative formative e percorsi di crescita dedicati ai consulenti, finalizzati a migliorare la qualità dell&apos;esperienza offerta agli utenti.</p>
                    <p>Tra questi progetti rientra anche lo sviluppo della Klaro7 Academy, pensata come spazio di formazione e confronto professionale.</p>
      
                    <h3>Le recensioni influenzano la presenza dei consulenti sulla piattaforma?</h3>
                    <p>Sì. Le recensioni degli utenti rappresentano uno degli elementi che contribuiscono alla valutazione complessiva dei consulenti.</p>
                    <p>Klaro7 monitora costantemente la qualità del servizio offerto per mantenere elevati standard professionali.</p>
      
                    <h3>Un consulente può essere sospeso o rimosso dalla piattaforma?</h3>
                    <p>Nel caso in cui un consulente non rispetti gli standard qualitativi o le regole della piattaforma, Klaro7 può adottare misure che includono:</p>
                    <ul>
                      <li>richiami formali</li>
                      <li>sospensione temporanea dell&apos;account</li>
                      <li>cessazione della collaborazione</li>
                    </ul>
                    <p>Queste misure hanno lo scopo di tutelare la qualità del servizio e la fiducia degli utenti.</p>
      
                    <h2>Recensioni e valutazioni su Klaro7</h2>
      
                    <h3>Come funzionano le recensioni su Klaro7?</h3>
                    <p>Al termine di ogni consulto (telefonata, chat o videochiamata), l&apos;utente può lasciare una recensione relativa all&apos;esperienza ricevuta.</p>
                    <p>Il sistema prevede:</p>
                    <ul>
                      <li>una valutazione numerica</li>
                      <li>un commento facoltativo</li>
                      <li>la selezione di specifici aspetti del consulto</li>
                    </ul>
                    <p>Le recensioni contribuiscono alla trasparenza della piattaforma e aiutano altri utenti nella scelta del consulente.</p>
      
                    <h3>Quali aspetti possono essere valutati?</h3>
                    <p>Il sistema di valutazione è strutturato e può includere elementi quali:</p>
                    <ul>
                      <li>Chiarezza comunicativa</li>
                      <li>Professionalità</li>
                      <li>Empatia</li>
                      <li>Coerenza del consulto</li>
                      <li>Esperienza complessiva</li>
                    </ul>
                    <p>Questo consente una valutazione più equilibrata e meno generica.</p>
      
                    <h3>Le recensioni sono pubbliche?</h3>
                    <p>Sì. Le recensioni sono visibili pubblicamente nel profilo del consulente, nel rispetto delle regole di correttezza e moderazione della piattaforma.</p>
      
                    <h3>Posso lasciare una recensione senza aver effettuato un consulto?</h3>
                    <p>No. Possono lasciare una recensione esclusivamente gli utenti che hanno effettivamente completato un consulto tramite Klaro7.</p>
      
                    <h3>I consulenti possono rispondere alle recensioni?</h3>
                    <p>Sì. I consulenti possono rispondere pubblicamente alle recensioni ricevute.</p>
                    <p>Le risposte devono mantenere un tono professionale, rispettare la riservatezza dell&apos;utente e aderire allo Standard Klaro7.</p>
      
                    <h3>Le recensioni e le risposte vengono moderate?</h3>
                    <p>Klaro7 non modifica il contenuto delle recensioni.</p>
                    <p>Si riserva tuttavia la facoltà di rimuovere contenuti:</p>
                    <ul>
                      <li>offensivi</li>
                      <li>diffamatori</li>
                      <li>non pertinenti</li>
                      <li>in violazione delle regole della piattaforma</li>
                    </ul>
                    <p>Lo stesso principio si applica alle risposte dei consulenti.</p>
      
                    <h3>Le recensioni influenzano la visibilità dei consulenti?</h3>
                    <p>Sì. Il sistema di valutazione rappresenta uno degli elementi che possono incidere sul ranking interno dei consulenti all&apos;interno della piattaforma.</p>
                    <p>Klaro7 promuove un ecosistema basato su qualità, chiarezza e professionalità.</p>
                    <p>Il rispetto dello Standard Klaro7 e il mantenimento di livelli qualitativi adeguati sono condizioni necessarie per operare sulla piattaforma.</p>
      
                    <h3>Cosa accade in caso di valutazioni ripetutamente basse?</h3>
                    <p>Nel caso in cui un consulente mantenga nel tempo valutazioni non coerenti con gli standard qualitativi della piattaforma, Klaro7 può:</p>
                    <ul>
                      <li>attivare richiami formali</li>
                      <li>richiedere adeguamenti professionali</li>
                      <li>sospendere temporaneamente l&apos;account</li>
                      <li>interrompere la collaborazione</li>
                    </ul>
                    <p>L&apos;obiettivo è garantire un ambiente professionale e conforme ai principi dichiarati.</p>
      
                    <h2>Regole di comportamento</h2>
      
                    <h3>Quali comportamenti non sono consentiti su Klaro7?</h3>
                    <p>Per garantire un ambiente rispettoso e sicuro, non sono consentiti:</p>
                    <ul>
                      <li>Insulti, minacce o linguaggio offensivo</li>
                      <li>Tentativi di estorcere informazioni personali ai consulenti</li>
                      <li>Richieste di prestazioni estranee alla natura del servizio</li>
                      <li>Tentativi di contatto al di fuori della piattaforma</li>
                      <li>Qualsiasi comportamento fraudolento o illecito</li>
                    </ul>
                    <p>Non è consentito utilizzare la piattaforma per:</p>
                    <ul>
                      <li>Attività illecite</li>
                      <li>Riciclaggio di denaro</li>
                      <li>Tentativi di aggirare sistemi di pagamento</li>
                      <li>Uso fraudolento di strumenti finanziari</li>
                    </ul>
                    <p>Klaro7 promuove un clima di rispetto reciproco.</p>
      
                    <h3>Posso chiedere al consulente un contatto diretto fuori dalla piattaforma?</h3>
                    <p>No. Per motivi di sicurezza e tutela di entrambe le parti, è vietato scambiare contatti personali o spostare il consulto al di fuori di Klaro7.</p>
                    <p>Questo protegge:</p>
                    <ul>
                      <li>La tua sicurezza</li>
                      <li>La trasparenza del servizio</li>
                      <li>La correttezza economica del sistema</li>
                    </ul>
      
                    <h3>Cosa succede se un utente viola le regole?</h3>
                    <p>In caso di violazione delle regole, Klaro7 può:</p>
                    <ul>
                      <li>Inviare un richiamo</li>
                      <li>Sospendere temporaneamente l&apos;account</li>
                      <li>Procedere alla chiusura definitiva</li>
                    </ul>
                    <p>Le misure vengono adottate per tutelare la comunità e la qualità del servizio.</p>
      
                    <h3>I consulenti possono violare le regole?</h3>
                    <p>No. Anche i consulenti devono rispettare precise linee guida etiche e comportamentali.</p>
                    <p>In caso di segnalazioni fondate, Klaro7 può:</p>
                    <ul>
                      <li>Effettuare verifiche interne</li>
                      <li>Adottare provvedimenti disciplinari</li>
                      <li>Sospendere o rimuovere il consulente</li>
                    </ul>
      
                    <h3>Klaro7 può limitare temporaneamente l&apos;utilizzo del servizio?</h3>
                    <p>Sì. In caso di utilizzo anomalo, comportamenti sospetti o potenziali violazioni delle regole, Klaro7 può applicare limitazioni temporanee all&apos;account per effettuare verifiche.</p>
                    <p>Questa misura è adottata a tutela della sicurezza della piattaforma e degli utenti.</p>
      
                    <h2>Reclami, assistenza e contestazioni</h2>
      
                    <h3>Come posso contattare l&apos;assistenza Klaro7?</h3>
                    <p>Puoi contattare il servizio di assistenza tramite i canali indicati sul sito ufficiale.</p>
                    <p>Le richieste vengono prese in carico nel più breve tempo possibile, compatibilmente con la complessità del caso.</p>
                    <p><a href="mailto:assistenza@klaro7.com">assistenza@klaro7.com</a></p>
      
                    <h3>Entro quanto tempo posso contestare un consulto?</h3>
                    <p>Eventuali contestazioni relative ad un consulto devono essere comunicate entro un termine ragionevole dalla sua conclusione, come previsto dalle Condizioni Generali.</p>
                    <p>Le segnalazioni tardive potrebbero non essere prese in considerazione, soprattutto se il servizio risulta regolarmente fruito.</p>
      
                    <h3>Klaro7 garantisce il rimborso in caso di insoddisfazione?</h3>
                    <p>Il consulto è un servizio basato sull&apos;interazione personale e sull&apos;interpretazione simbolica.</p>
                    <p>Non è previsto un rimborso per semplice insoddisfazione soggettiva, salvo i casi specificamente previsti dalla normativa o dalle Condizioni Generali.</p>
                    <p>Prima di iniziare un consulto, ti invitiamo a scegliere con attenzione il consulente più in linea con le tue esigenze.</p>
      
                    <h3>Come vengono gestite le segnalazioni contro un consulente?</h3>
                    <p>Le segnalazioni vengono valutate internamente in modo riservato e imparziale.</p>
                    <p>Se emergono violazioni delle regole o delle linee guida, Klaro7 può adottare provvedimenti adeguati.</p>
                    <p>L&apos;obiettivo è garantire un ambiente serio, etico e professionale.</p>
      
                    <h3>Klaro7 può intervenire in caso di contestazioni abusive?</h3>
                    <p>Sì. Nel caso in cui vengano riscontrati comportamenti reiterati o contestazioni manifestamente infondate relative a servizi regolarmente fruiti, Klaro7 può adottare misure di tutela, inclusa la sospensione dell&apos;account.</p>
                    <p>L&apos;obiettivo è garantire equità e correttezza per tutti gli utenti e consulenti.</p>
      
                    <h3>Qual è la legge applicabile e il foro competente?</h3>
                    <p>I rapporti tra utente e piattaforma sono regolati dalla legge italiana, come indicato nelle Condizioni Generali.</p>
                    <p>Eventuali controversie saranno trattate secondo quanto previsto contrattualmente.</p>
      
                    <h2>Privacy e riservatezza dei consulti</h2>
      
                    <h3>I consulti su Klaro7 sono riservati?</h3>
                    <p>Sì. I consulti effettuati sulla piattaforma Klaro7 sono gestiti nel rispetto dei principi di riservatezza e tutela della privacy degli utenti.</p>
                    <p>Le conversazioni tra utente e consulente sono considerate private e devono svolgersi nel rispetto delle regole della piattaforma e della normativa vigente in materia di protezione dei dati personali.</p>
      
                    <h3>Le conversazioni vengono registrate?</h3>
                    <p>Klaro7 può adottare sistemi tecnici di monitoraggio o registrazione delle comunicazioni esclusivamente per finalità di sicurezza, qualità del servizio e gestione di eventuali segnalazioni.</p>
                    <p>L&apos;utilizzo di tali sistemi avviene nel rispetto della normativa applicabile e delle informative sulla privacy della piattaforma.</p>
      
                    <h3>I miei dati personali sono protetti?</h3>
                    <p>Sì. Klaro7 tratta i dati personali degli utenti nel rispetto della normativa sulla protezione dei dati personali e secondo quanto indicato nella Privacy Policy della piattaforma.</p>
                    <p>I dati vengono utilizzati esclusivamente per la gestione del servizio e non vengono diffusi senza base giuridica o consenso dell&apos;interessato.</p>
      
                    <h3>I consulenti possono divulgare informazioni sugli utenti?</h3>
                    <p>No. I consulenti Klaro7 sono tenuti a rispettare obblighi di riservatezza e a non divulgare informazioni relative agli utenti o ai consulti effettuati sulla piattaforma.</p>
                    <p>Il rispetto della privacy rappresenta uno degli elementi fondamentali degli standard professionali richiesti ai consulenti.</p>
      
                    <h3>Posso utilizzare un nickname invece del mio nome reale?</h3>
                    <p>Sì. Durante l&apos;utilizzo della piattaforma l&apos;utente può scegliere di utilizzare un nickname per tutelare ulteriormente la propria riservatezza nei confronti dei consulenti e degli altri utenti.</p>
    </LegalPageLayout>
  );
}
